/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

const Loading: React.FC = () => <div className='ms-checkout-section-container__loading' />;

export default Loading;
